import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHeadFromPage } from "@/config/seoHead";
import { scrapedPageQueryOptions } from "@/hooks/useScrapedPage";
import { lookupSlug, notFoundUnlessRedirected } from "@/lib/slugGuards";

const ArtikelDetalj = lazy(() => import("@/pages/content/ArtikelDetalj"));

export const Route = createFileRoute("/blogg/$slug")({
  // Ladda innehållet i SSR så sidan inte hoppar till efter hydrering.
  loader: async ({ params, context }) => {
    const path = `/blogg/${params.slug}`;
    const page = await lookupSlug(() => context.queryClient.ensureQueryData(scrapedPageQueryOptions(path)));
    // null = artikeln finns inte (404); undefined = uppslagningen misslyckades, rendera ändå.
    if (page === null) await notFoundUnlessRedirected(path);
    return { page };
  },
  head: ({ params, loaderData }) =>
    seoHeadFromPage(`/blogg/${params.slug}`, loaderData?.page, { ogType: "article" }),
  component: BloggDetaljRoute,
});

function BloggDetaljRoute() {
  const { page } = Route.useLoaderData();
  return <ArtikelDetalj initialPage={page} />;
}
